export const MAX_FILE_SIZE = 100 * 1024 * 1024; // 100MB
export const CHUNK_SIZE = 95 * 1024 * 1024; // 95MB for multipart uploads

export const DEFAULT_CHUNK_SIZE = 256 * 1024 * 1024; // 256MB